module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAVFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////8wXzyWAAAAHHRSTlMAqJejF1kpn0cbFAiJiHZhVCBukYBnT0E1MyQQXzdQSAAAALJJREFUGNNtzlkOwyAMRVE/zEzGJmmm/e+zCZRCpN4PZI4sBD1yBjHx5JGRomfBey0Kl6TA5f9UZ5a2X9QWkkqf2HWImcHdSol3BtpevQTAt1JgQ6QZzUF3lsEu/vM6J8whatwYKLXCnJSzMN+VDopKAlsedMWvvATIihWWNDDGinv0aWhgK27zTaEtevye9Ix31tCgy/OA7OcMdtWn0NpRamXAO5UGRmrSVOdVwxDdWuQDyv4FTCM60i8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/face/success/images/male.png
// module id = 2425
// module chunks = 0